// app/reportOre/reportOre.js

(function () {
    'use strict';
    var controllerId = 'reportOre';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$filter', 'datacontext', 'common', 'sectionMenu', '_', '$translate', reportOreFn]);

    function reportOreFn($rootScope, $scope, $filter, datacontext, common, sectionMenu, _, $translate) {
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = $translate.instant('ReportOreLavorate');
        vm.sectionMenu = sectionMenu.setSection('ReportOre');
        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.list = {};
        //Ordinamento
        vm.list.ordine = ['Dipendente', 'Commessa', 'Sezione'];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        //Liste
        vm.list.anni = [];
        vm.list.mesi = [];
        vm.list.giorni = [];
        vm.list.setttimane = [];
        vm.list.commesse = [];
        vm.list.cdc = [];
        vm.list.aziendePartner = [];
        vm.causali = [{ Name: $translate.instant('Ordinario'), Id: 1 }, { Name: $translate.instant('Straordinario'), Id: 3 }, { Name: $translate.instant('Trasferta'), Id: 4 }, { Name: 'Smart working', Id: 5 }, { Name: $translate.instant('OreDiViaggio'), Id: 2 }];

        //Somma
        vm.somma = 0;

        // Filtro
        vm.filter = {};
        vm.filter.anno = vm.fAnno = 0;
        vm.filter.mese = vm.fMese = 0;
        vm.filter.giorno = vm.fGiorno = 0;
        vm.filter.settimana = vm.fSettimana = 0;        
        vm.filter.commessa = vm.fCommessa = -1;
        vm.filter.cdc = vm.fCdc = -1;
        vm.filter.ricerca = vm.fRicerca = '';
        vm.filter.causale = vm.fCausale = -1;
        vm.filter.aziendaPartner = vm.fAziendaPartner = 0;

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.getPerformance = getPerformance;
        vm.strMese = '';
        vm.meseChanged = meseChanged;     

        // ---- ACTIVATE -------
        activate();

        function activate() {            
            var promises = [getListAnni(), getListMesi(), getListSettimane(), getListGiorni(), getListCommesse(), getListAziendePartner(), getListSezioni()];
            common.activateController(promises, controllerId).then(function () {   
            });
        }

        //****************************************************
        // METODI 
        //****************************************************        
        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.anno = vm.fAnno == null ? 0 : vm.fAnno;
            vm.filter.mese = vm.fMese == null ? 0 : vm.fMese;
            vm.filter.settimana = vm.fSettimana == null ? 0 : vm.fSettimana;
            vm.filter.giorno = vm.fGiorno == null ? 0 : vm.fGiorno;
            vm.filter.commessa = vm.fCommessa == null ? -1 : vm.fCommessa;
            vm.filter.cdc = vm.fCdc == null ? -1 : vm.fCdc;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;
            vm.filter.causale = vm.fCausale == null ? -1 : vm.fCausale;
            vm.filter.aziendaPartner = vm.fAziendaPartner == null ? 0 : vm.fAziendaPartner;

            vm.loading = false;
            countByFilter();
            getPerformance();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.reportOre_countAll(vm.filter.anno, vm.filter.mese, vm.filter.settimana, vm.filter.giorno, vm.filter.commessa, vm.filter.cdc, vm.filter.ricerca, vm.filter.causale, vm.filter.aziendaPartner).then(function (data) {
                if (data) {
                    vm.countRecords = data;

                    vm.somma = 0;
                    datacontext.reportOre_getTotale(vm.filter.anno, vm.filter.mese, vm.filter.settimana, vm.filter.giorno, vm.filter.commessa, vm.filter.cdc, vm.filter.ricerca, vm.filter.causale, vm.filter.aziendaPartner).then(function (data) {
                        if (data)
                            vm.somma = data;
                    });
                }
            });
        }

        function getAllByFilter() {            
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.reportOre_getAll(vm.pageSize, vm.page, vm.filter.anno, vm.filter.mese, vm.filter.settimana, vm.filter.giorno, vm.filter.commessa, vm.filter.cdc, vm.filter.ricerca, vm.filter.causale, vm.filter.aziendaPartner, vm.ordine.value).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;                   
                    vm.records.push.apply(vm.records, data);
                }
                vm.loading = false;                
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getListAnni() {
            vm.list.anni = [];            
            var item = {
                'Id': 0,
                'Name': '-- Tutti --'
            };
            vm.list.anni.push(item);

            for (var i = 0; i < 90; i++) {
                var item = {
                    'Id': 2010 + i,
                    'Name': String(2010 + i)
                };
                vm.list.anni.push(item);
            }            

            vm.filter.anno = vm.fAnno = new Date().getFullYear();
        }

        function getListMesi() {
            vm.list.mesi = [
                { 'Id': 0, 'Name': '-- Tutti --' },
                { 'Id': 1, 'Name': $translate.instant('Gennaio') },
                { 'Id': 2, 'Name': $translate.instant('Febbraio') },
                { 'Id': 3, 'Name': $translate.instant('Marzo') },
                { 'Id': 4, 'Name': $translate.instant('Aprile') },
                { 'Id': 5, 'Name': $translate.instant('Maggio') },
                { 'Id': 6, 'Name': $translate.instant('Giugno') },
                { 'Id': 7, 'Name': $translate.instant('Luglio') },
                { 'Id': 8, 'Name': $translate.instant('Agosto') },
                { 'Id': 9, 'Name': $translate.instant('Settembre') },
                { 'Id': 10, 'Name': $translate.instant('Ottobre') },
                { 'Id': 11, 'Name': $translate.instant('Novembre') },
                { 'Id': 12, 'Name': $translate.instant('Dicembre') }
            ];

            vm.filter.mese = vm.fMese = new Date().getMonth() + 1;

            meseChanged();
        }

        function getListSettimane() {
            vm.list.settimane = [];
            var item = {
                'Id': 0,
                'Name': $translate.instant('--Tutte--')
            };
            vm.list.settimane.push(item);

            for (var i = 1; i < 55; i++) {
                var item = {
                    'Id': i,
                    'Name': String(i)
                };
                vm.list.settimane.push(item);
            }            
        }

        function getListGiorni() {
            vm.list.giorni = [];
            var item = {
                'Id': 0,
                'Name': $translate.instant('--Tutti--')
            };
            vm.list.giorni.push(item);

            for (var i = 1; i < 32; i++) {
                var item = {
                    'Id': i,
                    'Name': String(i)
                };
                vm.list.giorni.push(item);
            }
        }

        function getListCommesse() {
            vm.list.commesse = [];
            return datacontext.commessa_getAllListForTimeSheet().then(function (data) {
                if (Array.isArray(data) && data.length > 0)
                    data.forEach(function (item) { vm.list.commesse.push(item); });

                return vm.list.commesse;
            });
        }

        function getListSezioni() {
            vm.list.cdc = [];
            return datacontext.sezione_getAllList().then(function (data) {
                return vm.list.cdc = data;
            });
        }
                
        function meseChanged() {
            switch (vm.fMese) {
                case 1:
                    vm.strMese = $translate.instant('Gennaio');
                    break;
                case 2:
                    vm.strMese = $translate.instant('Febbraio');
                    break;
                case 3:
                    vm.strMese = $translate.instant('Marzo');
                    break;
                case 4:
                    vm.strMese = $translate.instant('Aprile');
                    break;
                case 5:
                    vm.strMese = $translate.instant('Maggio');
                    break;
                case 6:
                    vm.strMese = $translate.instant('Giugno');
                    break;
                case 7:
                    vm.strMese = $translate.instant('Luglio');
                    break;
                case 8:
                    vm.strMese = $translate.instant('Agosto');
                    break;
                case 9:
                    vm.strMese = $translate.instant('Settembre');
                    break;
                case 10:
                    vm.strMese = $translate.instant('Ottobre');
                    break;
                case 11:
                    vm.strMese = $translate.instant('Novembre');
                    break;
                case 12:
                    vm.strMese = $translate.instant('Dicembre');
                    break;
            }
        }

        function getListAziendePartner() {
            return datacontext.aziendaPartner_getAllList().then(function (data) {
                return vm.list.aziendePartner = data;
            });
        }

        function getPerformance() {
            //Inizializzo la scala del grafico
            vm.maxValue = 10;
            //vm.loading = true;

            $scope.graficoPerformance = {
                'type': 'AreaChart',
                'options': {
                    'legend': { 'position': 'none' },
                    'colors': ['#002854'],
                    'vAxis': {
                        'title': $translate.instant('OreLavoro'),
                        'titleTextStyle': { color: '#333' },
                        'minValue': 0,
                        'maxValue': parseInt(vm.maxValue)
                    },
                    'hAxis': {
                        'textPosition': 'none',
                        'gridlines': { 'count': 10 }
                    },
                    'pointSize': 8
                },
                'formatters': {
                    'number': [
                        {
                            'columnNum': 1,
                            'decimalSymbol': ',',
                            'fractionDigits': 2,
                            'groupingSymbol': '.'
                        }
                    ]
                }
            };

            //Inizializzo il grafico
            $scope.graficoPerformance.data = {
                "cols": [
                    { id: "description", label: "Data", type: "string" },
                    { id: "ore", label: $translate.instant('OreLavoro'), type: "number" }
                ],
                "rows": []
            };            

            datacontext.reportOre_getSum(vm.filter.anno, vm.filter.mese, vm.filter.settimana, vm.filter.giorno, vm.filter.commessa, vm.filter.cdc, vm.filter.ricerca, vm.filter.causale, vm.filter.aziendaPartner).then(function (data) {                                
                if (data == null || data == "500" || data.length == 0) {
                    $scope.graficoPerformance.data = {
                        "cols": [
                            { id: "description", label: "Data", type: "string" },
                            { id: "ore", label: $translate.instant('OreLavoro'), type: "number" }
                        ],
                        "rows": []
                    };

                    return;
                }

                var sortedPerformance = data;
                vm.primaData = $filter('dateFromValues')(_.first(sortedPerformance).Giorno, _.first(sortedPerformance).Mese, _.first(sortedPerformance).Anno);
                vm.ultimaData = $filter('dateFromValues')(_.last(sortedPerformance).Giorno, _.last(sortedPerformance).Mese, _.last(sortedPerformance).Anno);

                $scope.graficoPerformance.data = {
                    "cols": [
                        { id: "description", label: "Data", type: "string" },
                        { id: "ore", label: $translate.instant('OreLavoro'), type: "number" }
                    ],
                    "rows": []
                };

                sortedPerformance.forEach(function (obj) {
                    var item = {};
                    item.c = [];
                    var tmpMaxValue = vm.maxValue;

                    var desc = $filter('dateFromValues')(obj.Giorno, obj.Mese, obj.Anno);

                    if (obj.SommaOre > tmpMaxValue)
                        tmpMaxValue = obj.SommaOre + 10;

                    item.c.push({ v: desc });
                    item.c.push({ v: obj.SommaOre });

                    $scope.graficoPerformance.data.rows.push(item);

                    if (tmpMaxValue > vm.maxValue)
                        vm.maxValue = tmpMaxValue;
                });
            });            
        }        
    }
})();